;; Copied from workspace/projects/app/src-cljs/dre/components/input_pills/suggestions.cljs

(ns dre.components.searchbar.suggestion-util
  (:require
   [cljs-time.format :as f]
   [cljs-time.core :as t]
   ["fuse.js" :as Fuse]
   [clojure.string :as str]
   [dre.coll :refer [distinct-by tzipmap somev]]
   [dre.config :as config]
   [dre.shared.interface.search.pills :as pills]
   [dre.util :refer [unkeyword]]
   [taoensso.timbre :refer [error]]))

(def range-formatter
  (f/formatter "yyyy-MM-dd"))

(def formatters
  [(f/formatter "yyyy")
   (f/formatter "yyyy-")
   (f/formatter "yyyy-0")
   (f/formatter "yyyy-MM")
   (f/formatter "yyyy-MM-")
   (f/formatter "yyyy-MM-0")
   (f/formatter "yyyy-MM-dd")])

(defn mparse
  [f x]
  (when (< 3 (count x))
    (try
      (f/parse f x)
      (catch :default _))))

(def base-syntax-suggestions-map*
  {"now" {:pill [(pills/range-pill :changed nil "n") (pills/range-pill :published nil "n")]}
   "today" {:pill [(pills/range-pill :changed nil "n") (pills/range-pill :published nil "n")]}
   "through" {:pill [(pills/range-pill :changed nil "n") (pills/range-pill :published nil "n")]}
  ;;  "study size" {:pill [(pills/study-size-pill -1 -1)]}
  ;;  "size" {:pill [(pills/study-size-pill -1 -1)]}
   "and" {:pill [(pills/syntax-pill "and")] :allow-space? true}
   "with" {:pill [(pills/syntax-pill "with")] :allow-space? true}
   "or" {:pill [(pills/syntax-pill "or")] :allow-space? true}
   "not" {:pill [(pills/syntax-pill "not")] :allow-space? true}

   "(" {:pill [(pills/syntax-pill "l")] :allow-space? true}
   ")" {:pill [(pills/syntax-pill "r")] :allow-space? true}
   "ancestors" {:pill [(pills/syntax-pill "ppmancestors")]}
   "ascendants"  {:pill [(pills/syntax-pill "ppmancestors")]}
   "broader"  {:pill [(pills/syntax-pill "ppmancestors")]}

   "descendants" {:pill [(pills/syntax-pill "ppmdescendants")]}
   "descendants 1" {:pill [(pills/syntax-pill "ppmshallowdescendants")]}
   "shallow descendants" {:pill [(pills/syntax-pill "ppmshallowdescendants")]}
   "explode" {:pill [(pills/syntax-pill "ppmdescendants")]}
   "no descendants" {:pill [(pills/syntax-pill "ppmnoexplode")]}
   "without descendants" {:pill [(pills/syntax-pill "ppmnoexplode")]}
   "no explode" {:pill [(pills/syntax-pill "ppmnoexplode")]}
   "specific"  {:pill [(pills/syntax-pill "ppmdescendants")]}

   "may treat" {:pill [(pills/syntax-pill "ppmtreatments")]}
   "treatments" {:pill [(pills/syntax-pill "ppmtreatments")]}

   "causes" {:pill [(pills/syntax-pill "ppmcauses")]}
   "caused by" {:pill [(pills/syntax-pill "ppmcauses")]}

   "manufacturers for" {:pill [(pills/syntax-pill "ppmmanufacturersfor")]}
   "labellers for" {:pill [(pills/syntax-pill "ppmlabellersfor")]}
   "packagers for" {:pill [(pills/syntax-pill "ppmpackagersfor")]}


   "manufactured by" {:pill [(pills/syntax-pill "ppmmanufacturedby")]}
   "labelled by" {:pill [(pills/syntax-pill "ppmlabelledby")]}
   "packaged by" {:pill [(pills/syntax-pill "ppmpackagedby")]}

   "has targets of" {:pill [(pills/syntax-pill "ppmhastargetsof")]}
   "targets of" {:pill [(pills/syntax-pill "ppmtargetsof")]}
   "has pathway of" {:pill [(pills/syntax-pill "ppmhaspathwayof")]}
   "pathway of" {:pill [(pills/syntax-pill "ppmpathwayof")]}
   "drug class" {:pill [(pills/syntax-pill "ppmdrugclass")]}})

(def base-syntax-suggestions-map
  (assoc base-syntax-suggestions-map*
         "boost" {:pill [(pills/syntax-pill "boost")] :allow-space? true}))

(def base-sentence-tag-suggestions-map
  {"in title" {:pill [(pills/syntax-pill "ststitle")]}
   "in title/abstract" {:pill [(pills/syntax-pill "ststitle-or-abstract")]}
   "in title/abstract/keywords" {:pill [(pills/syntax-pill "ststitle-or-abstract-or-keywords")]}
   "in keywords" {:pill [(pills/syntax-pill "stskeywords")]}
   "in title/keywords" {:pill [(pills/syntax-pill "ststitle-or-keywords")]}
   "in journal" {:pill [(pills/syntax-pill "stsjournal")]}
   "in abstract" {:pill [(pills/syntax-pill "stsabstract")]}
   "in affiliation" {:pill [(pills/syntax-pill "stsaffiliation")]}
   "in author affiliation" {:pill [(pills/syntax-pill "stsaffiliation")]}
   "in person affiliation" {:pill [(pills/syntax-pill "stsaffiliation")]}
   "in criteria" {:pill [(pills/syntax-pill "stscriteria")]}
   "in inclusion criteria" {:pill [(pills/syntax-pill "stsinclusion-criteria")]}
   "in exclusion criteria" {:pill [(pills/syntax-pill "stsexclusion-criteria")]}
   "in trial criteria" {:pill [(pills/syntax-pill "stscriteria")]}
   "in trial inclusion criteria" {:pill [(pills/syntax-pill "stsinclusion-criteria")]}
   "in trial exclusion criteria" {:pill [(pills/syntax-pill "stsexclusion-criteria")]}
   "in study center" {:pill [(pills/syntax-pill "stsstudy-center")]}
   "in eligibility criteria" {:pill [(pills/syntax-pill "stscriteria")]}
   "in sponsors" {:pill [(pills/syntax-pill "stssponsor")]}
   "in biomedical relationships" {:pill [(pills/syntax-pill "stsbiomedicalrelationships")]}
   "in congress" {:pill [(pills/syntax-pill "stscongress")]}
   "in interventions" {:pill [(pills/syntax-pill "stsinterventions")]}
   "in outcomes" {:pill [(pills/syntax-pill "stsoutcomes")]}
   "in conditions" {:pill [(pills/syntax-pill "stsconditions")]}})

(def base-sense-only-tag-suggestions-map
  {"presented" {:pill [(pills/syntax-pill "stspresented")]}})

(defn base-source-suggestions-map
  []
  (tzipmap (vals (config/source-labels))
           (map (fn [[source _label]]
                  (hash-map :pill (pills/source-pill source)
                            :source source))
                (config/source-labels))))

(def pubtype-tags
  [;;["D000068397" "Clinical Study" 4363]
   ["D000073843" "Equivalence Trial" 963]
   ["D000076362" "Adaptive Clinical Trial" 35]
   ["D000076942" "Preprint" 3054]
   ["D000077522" "Clinical Trial, Veterinary" 1783]
   ["D000078182" "Systematic Review" 183419]
   ["D000078323" "Observational Study, Veterinary" 333]
   ["D000078325" "Clinical Trial Protocol" 7286]
   ["D000081262" "Randomized Controlled Trial, Veterinary" 2606]
   ;;["D002363" "Case Reports" 2244665]
   ["D003160" "Comparative Study" 1907596]
   ["D016221" "Festschrift" 1688]
   ["D016417" "Bibliography" 15995]
   ["D016418" "Legal Case" 11061]
   ["D016419" "Classical Article" 6673]
   ["D016420" "Comment" 949971]
   ["D016421" "Editorial" 594952]
   ["D016422" "Letter" 1168437]
   ["D016423" "Congress" 66947]
   ["D016424" "Overall" 27762]
   ["D016425" "Published Erratum" 109898]
   ["D016426" "Scientific Integrity Review" 271]
   ["D016427" "Technical Report" 3212]
   ["D016428" "Journal Article" 31249317]
   ["D016429" "Clinical Conference" 7542]
   ;;["D016430" "Clinical Study" 985958]
   ;;["D016431" "Guideline" 16490]
   ["D016433" "News" 211394]
   ["D016435" "Directory" 6643]
   ["D016437" "Dictionary" 544]
   ["D016438" "Duplicate Publication" 901]
   ["D016439" "Corrected and Republished Article" 1618]
   ["D016440" "Retraction of Publication" 10955]
   ["D016441" "Retracted Publication" 10466]
   ["D016446" "Consensus Development Conference" 12252]
   ["D016447" "Consensus Development Conference, NIH" 801]
   ["D016448" "Multicenter Study" 313990]
   ;;["D016449" "Randomized Controlled Trial" 557028]
   ["D016453" "Periodical Index" 322]
   ;;["D016454" "Review" 2931233]
   ["D016456" "Historical Article" 367404]
   ;;["D017065" "Practice Guideline" 29570]
   ["D017203" "Interview" 30130]
   ;;["D017418" "Meta-Analysis" 151786]
   ["D017426" "Clinical Trial, Phase I" 23092]
   ["D017427" "Clinical Trial, Phase II" 36934]
   ["D017428" "Clinical Trial, Phase III" 19853]
   ["D017429" "Clinical Trial, Phase IV" 2265]
   ["D018431" "Newspaper Article" 18293]
   ["D018486" "Twin Study" 9125]
   ["D018848" "Controlled Clinical Trial" 94661]
   ["D019215" "Biography" 181245]
   ["D019477" "Portrait" 49170]
   ["D019484" "Address" 5345]
   ["D019531" "Lecture" 6887]
   ["D020485" "Legislation" 1672]
   ["D020493" "Autobiography" 3938]
   ["D022903" "Government Publication" 175]
   ["D023361" "Validation Study" 108420]
   ["D023362" "Evaluation Study" 261116]
   ["D029282" "Patient Education Handout" 5482]
   ["D054710" "Interactive Tutorial" 279]
   ["D054711" "Introductory Journal Article" 57094]
   ["D057405" "Webcast" 1079]
   ["D059040" "Video-Audio Media" 34427]
   ["D062210" "Personal Narrative" 6110]
   ["D064886" "Dataset" 1316]
   ;;["D064888" "Observational Study" 119697]
   ["D065007" "Pragmatic Clinical Trial" 2013]])

(def base-pubtype-suggestions-map
  (let [coll pubtype-tags
        mf #(str "PubMed " %)]
    (tzipmap (map second coll)
             (map (fn [[tag label cnt]]
                    {:pill (pills/tag-pill
                            (unkeyword (keyword "pubtype" tag))
                            (mf label))
                     :count cnt})
                  coll))))

(def extra-pill-list
  (let [pill-map (merge base-sentence-tag-suggestions-map
                        base-sense-only-tag-suggestions-map
                        base-syntax-suggestions-map)
        syntax (map (fn [[k _]] {:label k :type :syntax})
                    base-syntax-suggestions-map)
        sentence (map (fn [[k _]] {:label k :type :sentence})
                      base-sentence-tag-suggestions-map)
        sense (map (fn [[k _]] {:label k :type :sense})
                   base-sense-only-tag-suggestions-map)]
    (with-meta
      (concat syntax sentence sense)
      {:map pill-map})))

(def pubtype-pill-list
  (let [pill-map base-pubtype-suggestions-map
        pubtype (map (fn [[k _]] {:label k :type :syntax})
                     base-pubtype-suggestions-map)]
    (with-meta pubtype {:map pill-map})))

(def stoplist
  #{"of"})

(def brackets
  #{"(" ")"})

(defn filter-stoplist
  [input]
  (str/join
    " "
    (filter (complement stoplist)
            (str/split input #" "))))

(def extra-suggestions
  (Fuse. (clj->js extra-pill-list)
         #js {"shouldSort" true
              "threshold" 0.2
              "tokenize" true
              "distance" 100
              "keys" #js ["label"]}))

(def pubtype-suggestions*
  (Fuse. (clj->js pubtype-pill-list)
         #js {"shouldSort" true
              "threshold" 0.2
              "tokenize" true
              "distance" 100
              "keys" #js ["label"]}))

(defn search-suggestions
  [input]
  (when (or (brackets input)
            (> (count input) 1))
    (js->clj
     (try (.search extra-suggestions (filter-stoplist input))
          (catch :default e
            (error e)
            #js {}))
     :keywordize-keys true)))

(defn pubtype-suggestions
  [input]
  (when-not (str/blank? input)
    (when (str/starts-with? (str/lower-case input) "pubmed ")
      (let [l (map (comp :label :item)
                   (js->clj
                     (try (.search pubtype-suggestions* (filter-stoplist (subs input 7)))
                          (catch :default e
                            (error e)
                            #js {}))
                     :keywordize-keys true))
            e (map :pill
                   (sort-by :cnt > (map #(get (:map (meta pubtype-pill-list)) %) l)))]
        (take 10 e)))))

(defn source-pill-list
  []
  (let [pill-map (base-source-suggestions-map)
        sources (map (fn [[k _]] {:label k :type :source})
                     (base-source-suggestions-map))]
    (with-meta
      sources
      {:map pill-map})))

(defn source-suggestions-fuse
  []
  (Fuse. (clj->js (source-pill-list))
         (clj->js {:shouldSort true
                   :threshold 0.1
                   :matchAllTokens true
                   :tokenize true
                   :keys ["label"]})))

(defn search-source-suggestions
  [input]
  (when (> (count input) 1)
    (js->clj
      (try (.search
             (source-suggestions-fuse)
             (filter-stoplist input))
           (catch :default e
             (error e)
             #js {}))
      :keywordize-keys true)))

(defn source-suggestions
  [input _idx _pills]
  (when (and (not (str/blank? input))
             (< 2 (count input)))
    (let [suggestions (map :item (search-source-suggestions input))
          allowed-types #{:source}
          suggestions (filter #(allowed-types (keyword (:type %))) suggestions)
          suggestions (map (fn [{:keys [:label] :as p}]
                             (let [source (-> (get (base-source-suggestions-map) label)
                                              :source)
                                   source (keyword source)
                                   source-count (config/source->count source)]
                               (assoc p :count (or source-count 0)))) suggestions)
          suggestions (sort-by :count > suggestions)
          suggestions (take 15 suggestions)]
      (distinct-by :pill/query
                   (map (fn [{:keys [label]}]
                          (let [e (get (:map (meta (source-pill-list))) label)]
                            (assoc
                             (:pill e)
                             :autocomplete/allow-space? (:allow-space? e)
                             :suggestion/label label))) suggestions)))))

(defn allow-sentence-tag-suggestions?
  [idx pills]
  (when (and (integer? idx) (pos? (count pills)) (<= 1 idx (count pills)))
    (let [{:keys [:pill/type] :as pill} (nth pills (dec idx))]
      (or (= :term type) (= :text type) (= :senses type) (= :signal type)
          (= pills/rbracket (select-keys pill [:pill/type :pill/query]))))))

(defn allow-sense-tag-suggestions?
  [idx pills]
  (when (and (integer? idx) (pos? (count pills)) (<= 1 idx (count pills)))
    (let [{:keys [:pill/type] :as pill} (nth pills (dec idx))]
      (or (= :term type) (= :senses type)))))

(defn syntax-suggestions
  [input idx pills]
  (let [suggestions (map #(:item %) (search-suggestions input))
        allowed-types #{:syntax
                        (when (allow-sentence-tag-suggestions? idx pills)
                          :sentence)
                        (when (allow-sense-tag-suggestions? idx pills)
                          :sense)}
        suggestions (filter #(allowed-types (keyword (:type %))) suggestions)
        suggestions (mapcat (fn [{:keys [label]}]
                              (let [e (get (:map (meta extra-pill-list)) label)]
                                (map
                                 #(assoc %
                                         :autocomplete/allow-space? (:allow-space? e)
                                         :suggestion/label label)
                                 (:pill e)))) suggestions)
        no-pill-query? #(nil? (:pill/query %))
        non-distinct-suggestions (filter no-pill-query? suggestions)
        pill-query? #(not (nil? (:pill/query %)))
        distinct-suggestions (filter pill-query? suggestions)
        distinct-suggestions (distinct-by :pill/query distinct-suggestions)]
    (concat non-distinct-suggestions distinct-suggestions)))

(defn date-range-suggestions
  [input]
  (when (< 1 (count input))
    (let [oinput input
          input (get (re-matches #"(changed |last changed |last |published |approved )?(from |since |through )?(.*)" input) 3 input)
          query-date (first (keep #(mparse % input) formatters))
          default-date (mparse (f/formatter "yyyy-MM-dd") "2020-01-01")
          pdate (or query-date default-date)
          date (f/unparse range-formatter pdate)
          only-changed? (or (str/index-of oinput "changed") (str/starts-with? oinput "last "))
          only-published? (str/index-of oinput "published")
          only-approved? (str/index-of oinput "approved")
          only-from? (or (str/index-of oinput "from") (str/index-of oinput "since"))
          only-through? (str/index-of oinput "through")
          query-date? (not (nil? query-date))
          year-like? (= 4 (count input))
          next-year (f/unparse range-formatter (t/plus pdate (t/years 1)))]
      (when (or only-changed? only-published? only-approved? query-date?)
        (cond only-changed?
              (somev [(when-not only-through? (pills/range-pill :changed date nil))
                      (when-not only-from? (pills/range-pill :changed nil date))])
              only-published?
              (somev [(when (and (not only-through?)
                                 (not only-from?))
                        (pills/range-pill :published (subs date 0 4) (subs next-year 0 4)))
                      (when-not only-through? (pills/range-pill :published date nil))
                      (when-not only-from? (pills/range-pill :published nil date))])
              only-approved?
              (somev [(when (and (not only-through?)
                                 (not only-from?))
                        (pills/range-pill :approved (subs date 0 4) (subs next-year 0 4)))
                      (when-not only-through? (pills/range-pill :approved date nil))
                      (when-not only-from? (pills/range-pill :approved nil date))])
              year-like?
              (somev
               [(when (and (not only-through?)
                           (not only-from?))
                  (pills/range-pill :published (subs date 0 4) (subs next-year 0 4))
                  (pills/range-pill :approved (subs date 0 4) (subs next-year 0 4)))
                (when-not only-through? (pills/range-pill :published date nil))
                (when-not only-from? (pills/range-pill :published nil date))
                (when-not only-through? (pills/range-pill :approved date nil))
                (when-not only-from? (pills/range-pill :approved nil date))
                (when-not only-through? (pills/range-pill :changed date nil))
                (when-not only-from? (pills/range-pill :changed nil date))])
              :else
              (somev [(when-not only-through? (pills/range-pill :published date nil))
                      (when-not only-from? (pills/range-pill :published nil date))
                      (when-not only-through? (pills/range-pill :approved date nil))
                      (when-not only-from? (pills/range-pill :approved nil date))
                      (when-not only-through? (pills/range-pill :changed date nil))
                      (when-not only-from? (pills/range-pill :changed nil date))]))))))

(defn reldate-range-suggestions
  [input]
  (when (pos? (count input))
    (let [oinput input
          maybe? (re-matches #"past.*" input)
          input (get (re-matches #"(changed |last changed |last |published |approved )?past (.*)" input) 2 input)
          amount (js/parseInt input)
          amount (if (and (js/isNaN amount) maybe?)
                   1 amount)
          only-changed? (or (str/index-of oinput "changed") (str/index-of oinput "last"))
          only-published? (str/index-of oinput "published")
          only-approved? (str/index-of oinput "approved")
          only-days? (str/index-of oinput "day")
          only-weeks? (str/index-of oinput "week")
          only-months? (str/index-of oinput "month")
          only-years? (str/index-of oinput "year")]
      (when (< 0 amount 99)
        (cond
          (and only-changed? only-days?)
          [(pills/range-pill :changed (str "d" amount) nil)]
          (and only-changed? only-weeks?)
          [(pills/range-pill :changed (str "w" amount) nil)]
          (and only-changed? only-months?)
          [(pills/range-pill :changed (str "m" amount) nil)]
          (and only-changed? only-years?)
          [(pills/range-pill :changed (str "y" amount) nil)]

          (and only-published? only-days?)
          [(pills/range-pill :published (str "d" amount) nil)]
          (and only-published? only-weeks?)
          [(pills/range-pill :published (str "w" amount) nil)]
          (and only-published? only-months?)
          [(pills/range-pill :published (str "m" amount) nil)]
          (and only-published? only-years?)
          [(pills/range-pill :published (str "y" amount) nil)]

          (and only-approved? only-days?)
          [(pills/range-pill :approved (str "d" amount) nil)]
          (and only-approved? only-weeks?)
          [(pills/range-pill :approved (str "w" amount) nil)]
          (and only-approved? only-months?)
          [(pills/range-pill :approved (str "m" amount) nil)]
          (and only-approved? only-years?)
          [(pills/range-pill :approved (str "y" amount) nil)]

          only-days?
          [(pills/range-pill :published (str "d" amount) nil)
           (pills/range-pill :approved (str "d" amount) nil)
           (pills/range-pill :changed (str "d" amount) nil)]
          only-weeks?
          [(pills/range-pill :published (str "w" amount) nil)
           (pills/range-pill :approved (str "w" amount) nil)
           (pills/range-pill :changed (str "w" amount) nil)]
          only-months?
          [(pills/range-pill :published (str "m" amount) nil)
           (pills/range-pill :approved (str "m" amount) nil)
           (pills/range-pill :changed (str "m" amount) nil)]
          only-years?
          [(pills/range-pill :published (str "y" amount) nil)
           (pills/range-pill :approved (str "y" amount) nil)
           (pills/range-pill :changed (str "y" amount) nil)]

          only-changed?
          [(pills/range-pill :changed (str "y" amount) nil)
           (pills/range-pill :changed (str "m" amount) nil)
           (pills/range-pill :changed (str "w" amount) nil)
           (pills/range-pill :changed (str "d" amount) nil)]
          only-published?
          [(pills/range-pill :published (str "y" amount) nil)
           (pills/range-pill :published (str "m" amount) nil)
           (pills/range-pill :published (str "w" amount) nil)
           (pills/range-pill :published (str "d" amount) nil)]
          only-approved?
          [(pills/range-pill :approved (str "y" amount) nil)
           (pills/range-pill :approved (str "m" amount) nil)
           (pills/range-pill :approved (str "w" amount) nil)
           (pills/range-pill :approved (str "d" amount) nil)]

          :else
          [(pills/range-pill :published (str "y" amount) nil)
           (pills/range-pill :published (str "m" amount) nil)
           (pills/range-pill :published (str "w" amount) nil)
           (pills/range-pill :published (str "d" amount) nil)
           (pills/range-pill :approved (str "y" amount) nil)
           (pills/range-pill :approved (str "m" amount) nil)
           (pills/range-pill :approved (str "w" amount) nil)
           (pills/range-pill :approved (str "d" amount) nil)
           (pills/range-pill :changed (str "y" amount) nil)
           (pills/range-pill :changed (str "m" amount) nil)
           (pills/range-pill :changed (str "w" amount) nil)
           (pills/range-pill :changed (str "d" amount) nil)])))))

(defn study-size-suggestions
  [input]
  (when (< 4 (count input))
    (let [oinput input
          input (get (re-matches #"(size|study size|n)( )?(>|<)?(=)?( )?(.*)" input) 6 input)
          sizes (map js/parseInt (str/split input #" "))
          sizes (filter #(not (js/isNaN %)) sizes)
          sizes (filter pos? sizes)
          sizes (if (pos? (count sizes))
                  sizes
                  [100])
          min-size (when (seq sizes) (str (apply min sizes)))
          max-size (when (seq sizes) (str (apply max sizes)))
          >? (str/index-of oinput ">")
          <? (str/index-of oinput "<")
          =? (str/index-of oinput "=")
          single-size? (= min-size max-size)
          is-study-size? (and (or min-size max-size)
                              (or (= 0 (str/index-of oinput "study size"))
                                  (= 0 (str/index-of oinput "size"))
                                  (= 0 (str/index-of oinput "n="))
                                  (= 0 (str/index-of oinput "n ="))
                                  (= 0 (str/index-of oinput "n<"))
                                  (= 0 (str/index-of oinput "n <"))
                                  (= 0 (str/index-of oinput "n>"))
                                  (= 0 (str/index-of oinput "n >"))))]
      (when is-study-size?
        (cond >?
              [(pills/study-size-pill min-size nil)]
              <?
              [(pills/study-size-pill "0" max-size)]
              =?
              [(pills/study-size-pill min-size min-size)]
              single-size?
              [(pills/study-size-pill min-size nil)
               (pills/study-size-pill "0" max-size)
               (pills/study-size-pill min-size min-size)]
              :else
              [(pills/study-size-pill min-size nil)
               (pills/study-size-pill max-size nil)
               (pills/study-size-pill "0" min-size)
               (pills/study-size-pill "0" max-size)
               (pills/study-size-pill min-size max-size)])))))

(defn tag-suggestions
  [input _ _ tags only-tags?]
  (when (or (>= (count input) 1)
            only-tags?)
    (let [input (str/lower-case input)
          kf (fn [{label :name
                   tag-uuid :tag_uuid
                   owner :owner}]
               (when (str/starts-with? (str/lower-case label) input)
                 (pills/utag-pill tag-uuid owner)))
          tags (keep kf tags)]
      tags)))

(defn category-suggestions
  [input]
  (when (< 2 (count input))
    (let [linput (str/lower-case input)
          ff #(or (str/starts-with? (str/lower-case (:label %)) linput)
                  (str/includes? (str/lower-case (:label %)) (str " " linput)))
          categories (filter ff (config/allowed-categories))]
      (map #(pills/category-pill (:id %))
           categories))))

(defn signal-suggestions
  [input signals]
  (when (< 2 (count input))
    (let [linput (str/lower-case input)
          ff #(str/starts-with? (str/lower-case (:signal/title %)) linput)
          signals (filter ff signals)]
      (map #(pills/signal-pill %) signals))))

(def whitespace
  #{\space \, \.})

(defn trimr
  [label]
  (when (seq label)
    (let [lidx (dec (count label))
          c (nth label lidx)]
      (cond (contains? whitespace c)
            (recur (subs label 0 lidx))
            (= \) c)
            (if-let [start (str/last-index-of label \()]
              (recur (subs label 0 start))
              label)
            :else label))))

(defn author-suggestions
  [input _idx _pills]
  (when (and (< 2 (count input)) (< (count (str/split input #" ")) 5))
    (let [[lastname firstname] (pills/split-author input)
          lookup (str/join " " [lastname firstname])]
      ;; only show suggestion for author pill when having typed
      ;; lastname plus a space and a letter
      (when (and (not= 0 (str/index-of (str lastname) "author")) firstname)
        (let [label lookup
              coll (str/split lookup #"\s")
              coll (remove str/blank? (map (comp trimr str/trim) coll))
              lookup (str/join " " (keep identity coll))]
          [(pills/author-pill lookup label)])))))

(defn text-suggestions
  [input _idx _pills]
  (when (< 1 (count input))
    [(pills/text-pill (str/trim input))]))

(defn insert-group-suggestions
  [dict-pill & {:keys [only-tags? no-tags?]}]
  (let [ret (if-let [related (seq (:pill/related dict-pill))]
              (let [other (distinct
                           (mapv :pill/canonical-label
                                 (cons (dissoc dict-pill :pill/related) related)))]
                (cons {:pill/type :senses
                       :pill/query (:pill/query dict-pill)
                       :pill/other-senses (keep :pill/query related)
                       :pill/label (:pill/label dict-pill)
                       :pill/other-canonical-labels other}
                      (map #(assoc % ::indent true)
                           [] #_(cons (dissoc dict-pill :pill/related) related))))
              [dict-pill])]
    (cond 
      only-tags?
      (filter #(= (:pill/type %) :tag) ret)
      no-tags?
      (remove #(= (:pill/type %) :tag) ret)
      :else
      ret)))

(defn feed-source?
  [suggestion]
  (str/starts-with? (or (name (:pill/query suggestion)) "") "http"))

(defn congress-source?
  [suggestion]
  (str/starts-with? (or (:pill/query suggestion) "") "doc-congress"))

(defn who-ictrp-source?
  [suggestion]
  (str/starts-with? (or (:pill/query suggestion) "") "who-ictrp:"))

(defn new-suggestions
  [input idx mode pills dict-pills signals tags]
  (when-not (str/blank? input)
    (cond (str/blank? mode)
          (let [only-tags? (str/starts-with? input "#")
                input (if only-tags? (subs input 1) input)
                sources (source-suggestions input idx pills)]
            (if only-tags?
              (concat (tag-suggestions input idx pills tags only-tags?)
                      (pubtype-suggestions input)
                      (mapcat #(insert-group-suggestions % :only-tags? only-tags?) dict-pills))
              (concat (syntax-suggestions input idx pills)
                      (remove #(or (feed-source? %) (congress-source? %) (who-ictrp-source? %)) sources)
                      ;; :approved field is used in RegIntel but not in DocSearch
                      (remove #(= (:pill/field %) :approved) (reldate-range-suggestions input))
                      (remove #(= (:pill/field %) :approved) (date-range-suggestions input))
                      (study-size-suggestions input)
                      (category-suggestions input)
                      (pubtype-suggestions input)
                      (mapcat insert-group-suggestions dict-pills)
                      (tag-suggestions input idx pills tags only-tags?)
                      (signal-suggestions input signals)
                      (filter congress-source? sources)
                      (filter who-ictrp-source? sources)
                      (filter feed-source? sources)
                      (text-suggestions input idx pills)
                      (author-suggestions input idx pills))))
          (#{"descendants" "ancestors" "shallowdescendants"} mode)
          (map #(assoc % :suggestion/mode mode)
               (mapcat insert-group-suggestions dict-pills))
          (#{"single-subjects-w-umbrella"} mode)
          (mapcat insert-group-suggestions dict-pills)
          (#{"subjects-w-umbrella-w-text"} mode)
          (concat
           (mapcat #(insert-group-suggestions % :no-tags? true) dict-pills)
           (text-suggestions input idx pills))
          (#{"subjects-w-umbrella"} mode)
          (mapcat #(insert-group-suggestions % :no-tags? true) dict-pills)
          :else
          (map #(assoc % :suggestion/mode mode) dict-pills))))

(defn- ensure-keyword
  [x]
  (if (keyword? x)
    x
    (keyword x)))

(defn update-semgroups
  [x]
  (update x :suggestion/semgroups #(map ensure-keyword %)))

(defn suggestions->pills
  "TODO: docstring"
  [suggestions]
  (let [{:dict/keys [suggestions tag-suggestions]} suggestions
        suggestions (map update-semgroups suggestions)
        term-pills (map #(pills/suggested-pill %) suggestions)
        tag-pills (map #(pills/suggested-pill %) tag-suggestions)
        coll (take 3 tag-pills)
        coll (concat coll (take (- 10 (count coll)) term-pills))]
    coll))

(defn author-suggestions->pills
  "TODO: docstring"
  [suggestions]
  (let [{:keys [:dict/author-suggestions]} suggestions
        result (mapv #(pills/author-pill %) author-suggestions)]
    result))
